module.exports = __webpack_public_path__ + "media/images/hrms/facebook-svg-58bed4003a9b94d82768613fc6fd161c.svg";